import { createSlice } from '@reduxjs/toolkit';
import AxiosAdapter from './AxiosAdapter';

import { MESSAGE } from 'src/app/constant/message';
import { HTTP_GETTYPE, STATUS_API } from '../app/constant/config';

export const getListSafeZones = AxiosAdapter.GetHttp(
  'safeZoneSlice/getListSafeZones',
  '/safe_zone',
  HTTP_GETTYPE.ALL_PAGINATION
);

export const createSafeZone = AxiosAdapter.HttpPost(
  'safeZoneSlice/createSafeZone',
  '/safe_zone',
  MESSAGE.CREATE_SAFE_ZONE_SUCCESS,
  MESSAGE.CREATE_SAFE_ZONE_FAIL
);

export const updateDeviceVersion = AxiosAdapter.HttpPut(
  'versionDeviceSlice/createDeviceVersion',
  '/device_versions/',
  MESSAGE.UPDATE_VERSIONDEVICE_SUCCESS,
  'Cập nhật phiên bản thiết bị thất bại'
);

export const updateSafeZone = AxiosAdapter.HttpPut(
  'safeZoneSlice/updateSafeZone',
  '/safe_zone/',
  MESSAGE.UPDATE_SAFE_ZONE_SUCCESS,
  MESSAGE.UPDATE_SAFE_ZONE_FAIL
);

export const deleteSafeZone = AxiosAdapter.HttpDelete(
  'safeZoneSlice/deleteSafeZone',
  '/safe_zone',
  MESSAGE.DELETE_SAFE_ZONE,
  MESSAGE.DELETE_SAFE_ZONE_FAIL
);

export const controlMaximumSpeed = AxiosAdapter.HttpUpdateById(
  'safeZoneSlice/controlMaximumSpeed',
  '/safe_zone/maximum-speed/auto/vehicle',
  'Tự động cập nhật tốc độ tối đa thành công',
  'Tự động cập nhật tốc độ tối đa thất bại'
);


export const safeZoneSlice = createSlice({
  name: 'safeZoneSlice',
  initialState: {
    listSafeZones: [],
    totalSafeZones: 0,

    error: null,
    statusGet: null,
    statusCreate: null,
    statusDelete: null,
    statusUpdate: null,
    statusControlMaximumSpeed: null,
    isLoading: false
  },

  reducers: {
    resetChange: state => {
      state.statusGet = null;
      state.statusCreate = null;
      state.statusControlMaximumSpeed = null;
      state.isLoading = false;
      state.error = null;
    }
  },

  extraReducers: {
    [getListSafeZones.pending]: state => {
      state.statusGet = STATUS_API.PENDING;
      state.isLoading = true;
    },
    [getListSafeZones.fulfilled]: (state, action) => {
      state.statusGet = STATUS_API.SUCCESS;
      state.listSafeZones = action.payload.payload.safeZones;
      state.totalSafeZones = action.payload.payload.numberOfItems;
      state.isLoading = false;
    },
    [getListSafeZones.rejected]: (state, action) => {
      state.statusGet = STATUS_API.ERROR;
      state.error = action.payload?.message || action.error;
      state.isLoading = false;
    },
    [createSafeZone.pending]: state => {
      state.statusCreate = STATUS_API.PENDING;
    },
    [createSafeZone.fulfilled]: (state, action) => {
      state.statusCreate = STATUS_API.SUCCESS;
    },
    [createSafeZone.rejected]: (state, action) => {
      state.statusCreate = STATUS_API.ERROR;
      state.error = action.payload?.message || action.error;
    },
    [deleteSafeZone.pending]: state => {
      state.statusDelete = STATUS_API.PENDING;
    },
    [deleteSafeZone.fulfilled]: (state, action) => {
      state.statusDelete = STATUS_API.SUCCESS;
    },
    [deleteSafeZone.rejected]: (state, action) => {
      state.statusDelete = STATUS_API.ERROR;
      state.error = action.payload?.message || action.error;
    },
    [updateSafeZone.pending]: state => {
      state.statusUpdate = STATUS_API.PENDING;
    },
    [updateSafeZone.fulfilled]: (state, action) => {
      state.statusUpdate = STATUS_API.SUCCESS;
    },
    [updateSafeZone.rejected]: (state, action) => {
      state.statusUpdate = STATUS_API.ERROR;
      state.error = action.payload?.message || action.error;
    },
    [controlMaximumSpeed.pending]: state => {
      state.statusControlMaximumSpeed = STATUS_API.PENDING;
    },
    [controlMaximumSpeed.fulfilled]: state => {
      state.statusControlMaximumSpeed = STATUS_API.SUCCESS;
    },
    [controlMaximumSpeed.rejected]: (state, action) => {
      state.statusControlMaximumSpeed = STATUS_API.ERROR;
      state.error = action.payload?.message;
    }
  }
});

export const { resetChange } = safeZoneSlice.actions;

export default safeZoneSlice.reducer;
